import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import { ClientSelectorComponent } from './client-selector/client-selector.component';
import { CreateComponent } from './create/create.component';

// Client controls are independent of profile pages and their embedded order list.
@NgModule({
  declarations: [ClientSelectorComponent, CreateComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatAutocompleteModule,
    MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule,
    MatProgressBarModule, MatSelectModule, MatSlideToggleModule, MatTooltipModule, NgxMaskModule],
  exports: [ClientSelectorComponent, CreateComponent]
})
export class ClientInputModule {}
